import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import SubscriptionGuard from './SubscriptionGuard';

export const ProtectedRoute = ({ children, permission, skipSubscription = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  console.log('ProtectedRoute - user:', user, 'loading:', loading);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg text-gray-600">Carregando...</div>
      </div>
    );
  }

  if (!user) {
    console.log('No user found, redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const permissions = new Set(user?.permissions || []);
  if (permission && !permissions.has(permission) && user?.role !== 'admin') {
    const fallback = permissions.has('dashboard.view')
      ? '/dashboard'
      : permissions.has('appointments.view')
        ? '/agenda'
        : permissions.has('billing.view')
          ? '/financeiro'
          : '/ajuda';
    return <Navigate to={fallback} replace />;
  }

  if (skipSubscription) return children;

  return (
    <SubscriptionGuard>
      {children}
    </SubscriptionGuard>
  );
};
